import {
  Component,
  ViewChild,
  OnDestroy,
  AfterViewInit,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'sp-add-files-modal',
  templateUrl: './add-files-modal.component.html',
  styleUrls: ['./add-files-modal.component.scss'],
  standalone: false
})
export class AddFilesModalComponent implements OnDestroy, AfterViewInit {

  @ViewChild(ModalDirective, { static: true }) public bsModal: ModalDirective;

  @Input() propertyId: string;
  @Input() folderId: string;
  /** When uploading from inside a per-project library folder, pass through so the file API can route uploads. */
  @Input() projectId: string | null = null;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

  value: any[] = [];

  readonly componentType = 'file';

  private ngOnDestroy$ = new Subject();

  ngAfterViewInit() {
    this.bsModal.config.keyboard = false;
    this.bsModal.config.ignoreBackdropClick = true;
  }

  showModal(): void {
    this.value = [];
    this.bsModal.show();
  }

  closeModal(): void {
    this.onClose.emit(true);
    this.bsModal.hide();
  }

  ngOnDestroy() {
    this.ngOnDestroy$.next('ngOnDestroy');
    this.ngOnDestroy$.unsubscribe();
  }
}
